import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import {
  IntakeSectionHeader,
  StyledGridCol,
  StyledGridRow,
} from "@/common/styles";
import { FormContainer } from "../InmateDetails/styles";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import { getOptionsFromRefList, hasCheckSecurity } from "@/util/common_function";
import { message } from "antd";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import { SCHEMA_FIELD_NAME, SCHEMA_NAME } from "@/util/common_variable";
import { useSelector } from "react-redux";

const ChargeInformation = ({ originalCustodyReasonID, startingPoint }) => {
  const { bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );
  const checkCount = (_, value) => {
    if (value > 0 && value <= 10000) {
      return Promise.resolve();
    }
    return Promise.reject(
      new Error("Count must be greater than 0 and less than 10000")
    );
  };
  const fullSearch = useSelector(state => state.fullSearch);
  return (
    <>
      <IntakeSectionHeader>
        <span>Charge Information</span>
      </IntakeSectionHeader>
      <FormContainer>
        <StyledGridRow gutter={16}>
          <StyledGridCol span={16}>
            <FormItem
              name="chargeDescriptionID"
              label="Charge"
              required={!fullSearch}
              rules={!fullSearch
                ? [
                  {
                    required: true,
                    message: "Charge is required",
                  },
                ] : []
              }
            >
              <Select
                options={getOptionsFromRefList("Charges", false, false, true)}
                placeholder="Charge"
                isSelectedValueFocus={true}
                variant="outlined"
                showSearch
                disabled={!bookingsFieldsEnabled || !hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.MODIFY, "", "", SCHEMA_NAME.CHARGES, SCHEMA_FIELD_NAME.CHARGE_DESCRIPTION_ID, startingPoint)}
                className={hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.VIEW, "", "", SCHEMA_NAME.CHARGES, SCHEMA_FIELD_NAME.CHARGE_DESCRIPTION_ID, startingPoint) ? "" : "input-control-mask"}
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol span={6}>
            <FormItem name="ucrCode" label="Code">
              <TextField disabled />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol span={6}>
            <FormItem
              name="chargeLevelID"
              label="Level"
              required={!fullSearch}
              rules={!fullSearch ? [
                {
                  required: true,
                  message: "Charge level is required",
                },
              ] : []}
            >
              <Select
                options={getOptionsFromRefList(
                  "Charge_Level",
                  false,
                  false,
                  true
                )}
                placeholder="Level"
                variant="outlined"
                disabled={!bookingsFieldsEnabled || !hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.MODIFY, "", "", SCHEMA_NAME.CHARGES, SCHEMA_FIELD_NAME.CHARGE_LEVEL_ID, startingPoint)}
                className={hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.VIEW, "", "", SCHEMA_NAME.CHARGES, SCHEMA_FIELD_NAME.CHARGE_LEVEL_ID, startingPoint) ? "" : "input-control-mask"}
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol span={6}>
            <FormItem
              name="chargeCount"
              label="Count"
              rules={!fullSearch ? [
                {
                  validator: checkCount,
                },
              ] : []}
            >
              <TextField type="number"
                disabled={!bookingsFieldsEnabled || !hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.MODIFY, "", "", SCHEMA_NAME.CHARGES, SCHEMA_FIELD_NAME.CHARGE_COUNT, startingPoint)}
                className={hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.VIEW, "", "", SCHEMA_NAME.CHARGES, SCHEMA_FIELD_NAME.CHARGE_COUNT, startingPoint) ? "" : "input-control-mask"}
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol span={6}>
            <FormItem name="chargeModifierID" label="Charge Modifier">
              <Select
                options={getOptionsFromRefList(
                  "Charge_Modifier",
                  false,
                  false,
                  true
                )}
                placeholder="Charge Modifier"
                variant="outlined"
                disabled={!bookingsFieldsEnabled || !hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.MODIFY, "", "", SCHEMA_NAME.CHARGES, SCHEMA_FIELD_NAME.CHARGE_MODIFIER_ID, startingPoint)}
                className={hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.VIEW, "", "", SCHEMA_NAME.CHARGES, SCHEMA_FIELD_NAME.CHARGE_MODIFIER_ID, startingPoint) ? "" : "input-control-mask"}
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol span={6}>
            <FormItem
              name="controllingAgencyORIID"
              label="Controlling Agency"
              required={!fullSearch}
              rules={!fullSearch ? [
                {
                  required: true,
                  message: "Controlling agency is required",
                },
              ] : []}
            >
              <Select
                options={getOptionsFromRefList(
                  "Controlling_Agency",
                  false,
                  true,
                  true
                )}
                placeholder="Controlling Agency"
                variant="outlined"
                showSearch
                disabled={!bookingsFieldsEnabled || !hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.MODIFY, "", "", SCHEMA_NAME.CHARGES, SCHEMA_FIELD_NAME.CONTROLLING_AGENCY_ORI_ID, startingPoint)}
                className={hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.VIEW, "", "", SCHEMA_NAME.CHARGES, SCHEMA_FIELD_NAME.CONTROLLING_AGENCY_ORI_ID, startingPoint) ? "" : "input-control-mask"}
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol span={6}>
            <FormItem
              name="caseNumber"
              label="Case Number"
              required={!fullSearch}
              rules={!fullSearch ? [
                {
                  required: true,
                  message: "Case number is required",
                },
                {
                  pattern: new RegExp(/^([A-Za-z]{2}\d{2}-\d{6}|\d{8})$/i),
                  message:
                    "The Case Number must be either 'aa##-######' (11 chars) or ######## (8 chars)",
                },
              ] : []}
            >
              <TextField
                disabled={!bookingsFieldsEnabled || !hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.MODIFY, "", "", SCHEMA_NAME.CHARGES, SCHEMA_FIELD_NAME.CASE_NUMBER, startingPoint)}
                className={hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.VIEW, "", "", SCHEMA_NAME.CHARGES, SCHEMA_FIELD_NAME.CASE_NUMBER, startingPoint) ? "" : "input-control-mask"}
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol span={6}>
            <FormItem name="courtNumber" label="Court Number">
              <TextField
                disabled={!bookingsFieldsEnabled || !hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.MODIFY, "", "", SCHEMA_NAME.CHARGES, SCHEMA_FIELD_NAME.COURT_NUMBER, startingPoint)}
                className={hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.VIEW, "", "", SCHEMA_NAME.CHARGES, SCHEMA_FIELD_NAME.COURT_NUMBER, startingPoint) ? "" : "input-control-mask"}
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol span={6}>
            <FormItem
              name="originalCustodyReasonID"
              label="Original Custody Reason"
              required={!fullSearch}
              rules={!fullSearch ? [
                {
                  required: true,
                  message: "Original custody reason is required",
                },
              ] : []}
            >
              <Select
                options={getOptionsFromRefList(
                  "Reason_Held",
                  false,
                  false,
                  true
                )}
                placeholder="Original Custody Reason"
                variant="outlined"
                disabled={!bookingsFieldsEnabled || !hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.MODIFY, "", "", SCHEMA_NAME.CHARGES, SCHEMA_FIELD_NAME.ORIGINAL_CUSTODY_REASON_ID, startingPoint)}
                className={hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.VIEW, "", "", SCHEMA_NAME.CHARGES, SCHEMA_FIELD_NAME.ORIGINAL_CUSTODY_REASON_ID, startingPoint) ? "" : "input-control-mask"}
              />
            </FormItem>
          </StyledGridCol>
          {[
            54180010, 54180009, 54180011, 54180013, 54180007, 54180008,
            54180026, 54180020, 54180021, 54180019, 54180018, 54180023,
            54180022, 54180006, 54180016, 54180003, 54180017, 54180024,
          ]?.findIndex((k) => k === originalCustodyReasonID) !== -1 && (
              <StyledGridCol span={6}>
                <FormItem name="warrantNumber" label="Warrant Number">
                  <TextField
                    disabled={!bookingsFieldsEnabled || !hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.MODIFY, "", "", SCHEMA_NAME.CHARGES, SCHEMA_FIELD_NAME.WARRANT_NUMBER, startingPoint)}
                    className={hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.VIEW, "", "", SCHEMA_NAME.CHARGES, SCHEMA_FIELD_NAME.WARRANT_NUMBER, startingPoint) ? "" : "input-control-mask"}
                  />
                </FormItem>
              </StyledGridCol>
            )}

          {[54180007, 54180006, 54180002]?.findIndex(
            (k) => k === originalCustodyReasonID
          ) !== -1 && (
              <StyledGridCol span={6}>
                <FormItem name="ticketNumber" label="Ticket Number">
                  <TextField 
                    disabled={!bookingsFieldsEnabled || !hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.MODIFY, "", "", SCHEMA_NAME.CHARGES, SCHEMA_FIELD_NAME.TICKET_NUMBER, startingPoint)}
                    className={hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.VIEW, "", "", SCHEMA_NAME.CHARGES, SCHEMA_FIELD_NAME.TICKET_NUMBER, startingPoint) ? "" : "input-control-mask"}
                    />
                </FormItem>
              </StyledGridCol>
            )}

          <StyledGridCol span={24}>
            <FormItem name="comments" label="Comments">
              <TextField inputType="textarea" rows={5}
              disabled={!bookingsFieldsEnabled || !hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.MODIFY, "", "", SCHEMA_NAME.CHARGES, SCHEMA_FIELD_NAME.COMMENTS, startingPoint)}
              className={hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.VIEW, "", "", SCHEMA_NAME.CHARGES, SCHEMA_FIELD_NAME.COMMENTS, startingPoint) ? "" : "input-control-mask"} 
              />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>
        <StyledGridRow gutter={16}></StyledGridRow>
        <StyledGridRow gutter={16}></StyledGridRow>
      </FormContainer>
    </>
  );
};

export default ChargeInformation;
